class MarqueeBar extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-target="viewport"]');
    this.track = this.querySelector('[data-target="track"]');
    if (!this.viewport || !this.track) return;

    // Keep a pristine copy of one track unit; every update rebuilds from it.
    this.unit = Array.from(this.track.children).map((node) => node.cloneNode(true));

    this.motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.handleChange = () => this.update();

    this.observer = new ResizeObserver(this.handleChange);
    this.observer.observe(this.viewport);
    this.motionQuery.addEventListener("change", this.handleChange);

    this.update();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.motionQuery) this.motionQuery.removeEventListener("change", this.handleChange);
  }

  available() {
    const styles = getComputedStyle(this.viewport);
    const inset = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    return this.viewport.clientWidth - inset;
  }

  update() {
    if (!this.unit.length) return;

    // Measure a single unit, unanimated.
    this.dataset.overflow = "false";
    this.track.replaceChildren(...this.unit.map((node) => node.cloneNode(true)));

    // Measure the content, not the stretched track: in the static state the
    // track is width:100%, so scrollWidth would just echo the container.
    this.track.style.width = "max-content";
    const contentWidth = this.track.scrollWidth;
    this.track.style.width = "";

    const overflows = contentWidth > this.available() + 1;
    if (!overflows) {
      this.dataset.motion = "off";
      return;
    }

    this.dataset.overflow = "true";
    this.dataset.motion = this.motionQuery.matches ? "off" : "on";

    // Two identical units make translateX(-50%) a seamless single-unit loop.
    // Each child carries its own trailing margin, so both halves are equal width.
    this.track.append(...this.unit.map((node) => node.cloneNode(true)));
  }
}

if (!customElements.get("marquee-bar")) {
  customElements.define("marquee-bar", MarqueeBar);
}
